import { useEffect, useState } from 'react';

import useUser from 'api/hooks/useUser';

const countryObject: {[key: string]: string} = {
  AUD: 'AU$',
  BRL: 'R$',
  CNY: '¥',
  CZK: 'Kč',
  DKK: 'kr.',
  EUR: '€',
  GBP: '£',
  HRK: 'HRK',
  HUF: 'HUF',
  IDR: 'IDR',
  MYR: 'MYR',
  NOK: 'NOK',
  NZD: 'NZ$',
  PLN: 'zł',
  RON: 'RON',
  SEK: 'SEK',
  USD: '$',
  CHF: 'CHF',
};

const useCurrency = () => {
  const [value, $value] = useState<string>('');
  const [value1, $value1] = useState<string>('');
  const { data } = useUser();

  useEffect(() => {
    const green = data?.greenCurrency?.code;
    const blue = data?.blueCurrency?.code;
    $value(countryObject?.[`${blue}`]);
    $value1(countryObject?.[`${green}`]);
  }, [data]);

  return { currencyBlue: value,
    currencyGreen: value1 };
};

export default useCurrency;
